import Grid, { GridItem, GridItemStill, GridSize, ObjectFit } from '../../generic/Grid';
import React, { useEffect, useState } from 'react';
import Section, { size } from '../../generic/Section';

import GridItemHero from '../../generic/Grid/GridItemHero';
import { Link } from 'gatsby';
import styles from './index.module.scss';

export default function WorkspaceDevices({ heading, workspaces, description = '', id = undefined }) {
  const [qualifiedWorkspaces, setQualifiedWorkspaces] = useState([]);

  useEffect(() => {
    setQualifiedWorkspaces(
      workspaces
        ?.map(wsp => {
          let [parentWorkspaceSubCategory] = wsp.workspaceSubCategory || [];
          if (!parentWorkspaceSubCategory) return null;
          let [parentWorkspaceCategory] = parentWorkspaceSubCategory.workspaceCategory || [];
          if (!parentWorkspaceCategory) return null;

          wsp.url = ['/workspaces', parentWorkspaceCategory?.slug, parentWorkspaceSubCategory?.slug, wsp.slug].join(
            '/'
          );
          return wsp;
        })
        .filter(Boolean)
    );
  }, [workspaces]);

  if (!qualifiedWorkspaces || qualifiedWorkspaces.length === 0) {
    return null;
  }

  return (
    <Section id={id} size={size.max}>
      <Grid>
        <GridItemHero heading={heading} description={description} />
        {qualifiedWorkspaces?.map((wsp, index) => {
          return <GridItemWrapper key={index} {...{ wsp }} />;
        })}
      </Grid>
    </Section>
  );
}

function GridItemWrapper({ wsp }) {
  let [workspaceImage = wsp.hotspotHero] = wsp.images || [];
  let { x, y } = {
    x: !isNaN(workspaceImage?.focalPoint?.x) ? workspaceImage.focalPoint.x : 50,
    y: !isNaN(workspaceImage?.focalPoint?.y) ? workspaceImage?.focalPoint?.y : 50,
  };
  let imagePosition = `${x}% ${y}%`;

  return (
    <GridItem key={wsp.id} gridSize={GridSize.defaultWithImage}>
      <Link className={styles.link} to={wsp.url}>
        <GridItemStill
          key={wsp.id}
          objectFit={ObjectFit.cover}
          objectPosition={imagePosition}
          heading={wsp.heading}
          description={wsp.workspaceSubCategory?.[0].description?.description}
          backgroundColor={wsp.backgroundColor}
          image={workspaceImage?.image}
          numberOfSeats={wsp.workspaceSubCategory?.numberOfSeats}
          physicalSizeM2={wsp.workspaceSubCategory?.physicalSizeM2}
          gridSize={GridSize.defaultWithImage}
          gridImagePad
        />
      </Link>
    </GridItem>
  );
}
